import { InvoiceHook } from '@models';
import { Order } from '@services';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useInvoiceByOrderId = (order: Order | undefined): InvoiceHook => {
  const { invoiceStore } = useStore();
  const { invoice, loading } = invoiceStore;

  useEffect(() => {
    invoiceStore.clearInvoice();
    return () => {
      invoiceStore.clearInvoice();
    };
  }, [invoiceStore]);

  useEffect(() => {
    if (order?.id && (order?.status === 'Paid' || order?.status === 'Ready')) {
      invoiceStore.getByOrderId({ id: order.id });
    }
  }, [invoiceStore, order?.id, order?.status]);

  return { invoice, loading };
};
